export const BEACH_CHECKS = '/api/BeachCheck';

export const MESSAGES = {
  REQUIRED_NAME: 'Beach check name is required!',
  BEACH_CHECK_CREATED: 'Beach Check created successfully.',
  BEACH_CHECK_UPDATED: 'Beach check updated successfully.',
  BEACH_CHECK_DELETED: 'Beach check deleted successfully.',
  CONFIRM_CHANGES_UNSAVED:
    'You have unsaved changes on the current beach check details. If you proceed to load another beach check, all unsaved changes will be lost.',
};
